<div class="container">
  <h1 class="title">Productos de limpieza por mayor, fabrica de productos de limpieza</h1>
</div>
<div class="container">
  <ng-container *ngFor="let familia of familias; let i = index">
    <div class="bannercategoria" [ngClass]="i % 2 === 0 ? 'left' : 'right'" *ngIf="banner(familia)">
      <a [routerLink]="['/', familia.texto]">
        <img width="831" height="176" [ngClass]="'lazyload'" [attr.data-src]="banner(familia)" [alt]="familia.texto">
      </a>
    </div>
  </ng-container>
</div>
